export default __webpack_public_path__ + "static/logo-846a5d58cc859c3a6602ac1c9dd0276c.svg";